@if (isActive()) {
  <div class="flex w-full h-full items-start overflow-hidden">
    <proffeo-task-time-reports
      [task]="task()"
      class="w-full"
    />
  </div>
}
